import type { QueryClient } from "@tanstack/react-query";
import type { MagicLinkRedirect } from "@shared/schemas/magic-link.schemas";
import type {
  MagicLinkType,
  GetMagicLinksByEntityInput,
  GetMagicLinksByEntityOptions,
} from "@frontend/shared/features/magic-links/domain/types/magic-link.types";
import { BaseApiHooksRepository } from "../../base-api-hooks.repository";
import { createMagicLinksApi } from "./magic-links.api";
import type { AxiosInstance } from "axios";
import { MAGIC_LINKS_QUERY_KEYS } from "./magic-links-query-keys.constants";

export class MagicLinkHooksHttpRepositoryImpl extends BaseApiHooksRepository {
  private readonly api;

  constructor(queryClient: QueryClient, apiClient: AxiosInstance) {
    super(queryClient);
    this.api = createMagicLinksApi(apiClient);
  }

  createHooks() {
    return {
      useGetByEntity: (
        input: GetMagicLinksByEntityInput,
        options: GetMagicLinksByEntityOptions = {},
      ) => {
        const { enabled = true } = options;

        return this.query<readonly MagicLinkType[], readonly MagicLinkType[]>({
          key: MAGIC_LINKS_QUERY_KEYS.byEntity(
            input.type,
            input.entityIdPublic,
          ),
          fn: () => this.api.getByEntity(input.type, input.entityIdPublic),
          parse: (data) => data,
          enabled: enabled && input.entityIdPublic !== "",
          staleTime: 30 * 1000, // 30 seconds
          retry: 1,
        });
      },

      useProcessMagicLink: () => {
        return this.mutation<MagicLinkRedirect, MagicLinkRedirect, string>({
          fn: (magicLinkIdPublic) => this.api.process(magicLinkIdPublic),
          parse: (data) => data,
        });
      },
    };
  }
}
